import React, { useState } from 'react';
import { SeatingPlan } from 'iticket-seatingplan';
import { Modal } from '../../themes/nzf_2022';
import CloseModal from './close-button';

const apiKey = document.querySelector('[name=iticket-api-key]').getAttribute('content');
const baseURL = 'https://ecommerce-main-7edd4c0.zuplo.app';

const SeatingSelection = ({ closeModal, eventName, session, sessionId, numTickets, iticketEventId, showingId, ticketPrice, ticketsInCart, priceAgeId, showingUid, setShowTicketAddedToCart }) => {
  let numSelectedTickets = 0;
  if (ticketsInCart) {
    ticketsInCart.map(ticket => {
      if (ticket.price === ticketPrice) {
        numSelectedTickets++;
      }
    });
  }
  const [selectedTickets, setSelectedTickets] = useState(numSelectedTickets);
  const [moveForward, setMoveForward] = useState(false);
  const seatingCallback = ({ type, details }) => {
    if (type !== 'cart-change') {
      return;
    }
    setSelectedTickets(details.length);
    if ((details.length) === (numSelectedTickets + numTickets)) {
      setMoveForward(true);
    }
  };

  return (
    <Modal
      onCloseCB={ closeModal }
      parsedContent={ (
        <div className='flex flex-column flex-ai-center w-11/12 mx-auto cyp-modal-inner'>
          <CloseModal />
          <h3 className='w-8/12 sm+:w-11/12 text-center u-text-no-transform mx-auto'>
            Select your seat
            <span>s</span>
          </h3>
          <p className='u-text-no-transform mt-5 mb-10'>
            <span className=''>{ eventName }</span>
            { session.start_date_human ? `, ${ session.start_date_human }` : ''}
            {' '}
            { session.start_time_human ? `, ${ session.start_time_human }` : ''}
          </p>
          <SeatingPlan
            eventId={ iticketEventId }
            showingUid={ showingUid }
            sessionId={ sessionId }
            showingId={ showingId }
            priceAgeId={ priceAgeId }
            quantity={ (numTickets + ticketsInCart.length) }
            price={ ticketPrice }
            callbackFunction={ seatingCallback }
            apiKey={ apiKey }
            baseUrl={ baseURL }
          />
          <p className='mb-5'>
            <span>{selectedTickets}</span>
            {' '}
            of
            {' '}
            <span>{ (numTickets + numSelectedTickets) }</span>
            {' '}
            seats selected
          </p>
          <button
            disabled={ !moveForward }
            type='button'
            className='btn btn--default btn--large w-11/12 mx-auto px-12 text-sm sm+:max-w-8/12 whitespace-normal mb-24'
            onClick={ () => setShowTicketAddedToCart(true) }
          >
            Add to cart
          </button>
        </div>
    ) }
    />
  );
};

export default SeatingSelection;
